import { render, staticRenderFns } from "./IconCheckCircleAlt.vue?vue&type=template&id=1b8e9335"
import script from "./IconCheckCircleAlt.vue?vue&type=script&lang=js"
export * from "./IconCheckCircleAlt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports